import { useState } from 'react'
import { Plus } from 'lucide-react'
import { router, usePage } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import { Switch } from '@/components/ui/switch'
import { Label } from '@/components/ui/label'
import { ServerDataTable, type PagyMeta } from '@/pages/People/_components/ServerDataTable'
import type CrmFundraisingDonationNature from '@/types/serializers/CrmFundraisingDonationNature'
import type { SharedProps } from '@/types'
import { donationNatureColumns } from './_components/DonationNatureColumns'
import { CreateDonationNatureSheet } from './_components/CreateDonationNatureSheet'

interface Props {
  donation_natures: CrmFundraisingDonationNature[]
  pagy: PagyMeta
  q?: Record<string, string>
}

export default function DonationNaturesIndex({
  donation_natures,
  pagy,
  q,
}: Props) {
  const [createOpen, setCreateOpen] = useState(false)
  const { auth } = usePage<{ auth: SharedProps['auth'] }>().props

  const isAdmin = auth.user?.role === 'space_admin'
  const showArchived = q?.with_discarded === 'true'

  function handleToggleArchived(checked: boolean) {
    router.get(
      '/fundraising/donation_natures',
      { q: { ...(q ?? {}), with_discarded: checked ? 'true' : undefined } },
      { preserveState: true, preserveScroll: true },
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Natures de don</h1>
          <p className="text-muted-foreground">
            Gestion des natures de don (spontane, zakat, etc.).
          </p>
        </div>
        {isAdmin && (
          <Button onClick={() => setCreateOpen(true)}>
            <Plus className="mr-2 h-4 w-4" />
            Nouvelle nature de don
          </Button>
        )}
      </div>

      {isAdmin && (
        <div className="flex items-center gap-2">
          <Switch
            id="dn_show_archived"
            checked={showArchived}
            onCheckedChange={handleToggleArchived}
          />
          <Label htmlFor="dn_show_archived">Inclure les archives</Label>
        </div>
      )}

      <ServerDataTable
        columns={donationNatureColumns}
        data={donation_natures}
        pagy={pagy}
        basePath="/fundraising/donation_natures"
      />

      {isAdmin && (
        <CreateDonationNatureSheet
          open={createOpen}
          onOpenChange={setCreateOpen}
        />
      )}
    </div>
  )
}
